











































import { Component, Prop, Vue } from 'vue-property-decorator';
import Counter from '@/components/commons/Counter.vue';
import { default as axios } from 'axios';
import { Utils } from '../../utils/utils';

@Component({
  components: { Counter },
})
export default class NewCollect extends Vue {
  public dialog: boolean = false;
  public iconResult: string = '';
  public explainationError: string = '';
  public eggsCount: number = 0;
  public disableBtn: boolean = false;

  public signalCollect() {
    const user: string = Utils.getCurrentUserName();
    this.disableBtn = true;
    axios
      .post(`${process.env.VUE_APP_API_URL}/hens`, {
        picker: user,
        number: this.eggsCount,
        date: new Date(),
      })
      .then(response => {
        this.iconResult = 'fa fa-thumbs-up';
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      })
      .catch(err => {
        this.iconResult = 'fa fa-exclamation-triangle';
        this.explainationError = err;
      });
  }
}
